import * as React from 'react';
import { GetCustomersBaseParams } from 'src/dto/CustomerNew';
import { GetAnalyticsParams } from 'src/dto/Analytics';
import { toISOStringCET } from 'src/utils/date';
import { AnalyticsWrapperProps, Wrapper } from 'src/pages/Analytics/components/AnalyticsDigitalScore';
import TopIdentities from 'src/components/TopIdentities';
import FrontendAnalyticsWrapper from 'src/components/FrontendAnalytics';

const AnalyticsEmail: React.FC<AnalyticsWrapperProps> = ({ dateRange, navigateTo }) => {
  const [customersFilters, setCustomersFilters] = React.useState<GetCustomersBaseParams>({
    start: 0,
    max_items: 5,
    search: null,
    start_date: toISOStringCET(dateRange.startDate),
    end_date: toISOStringCET(dateRange.endDate),
    score_cluster: undefined,
  });

  const [analyticsFilters, setAnalyticsFilters] = React.useState<GetAnalyticsParams>({
    start_date: toISOStringCET(dateRange.startDate),
    end_date: toISOStringCET(dateRange.endDate),
  });

  React.useEffect(() => {
    setCustomersFilters({
      ...customersFilters,
      start_date: toISOStringCET(dateRange.startDate),
      end_date: toISOStringCET(dateRange.endDate),
    });

    setAnalyticsFilters({
      start_date: toISOStringCET(dateRange.startDate),
      end_date: toISOStringCET(dateRange.endDate),
    });
  }, [dateRange]);

  return (
    <Wrapper>
      <FrontendAnalyticsWrapper
        product="Email"
        bestIdentities={
          <TopIdentities pathToDetail="customerEmail" customersFilters={customersFilters} tableTitle="Best Emails" type="best" navigateTo={navigateTo} />
        }
        worstIdentities={
          <TopIdentities pathToDetail="customerEmail" customersFilters={customersFilters} tableTitle="Worst Emails" type="worst" navigateTo={navigateTo} />
        }
        filters={customersFilters}
        analyticsFilters={analyticsFilters}
      />
    </Wrapper>
  );
};

export default AnalyticsEmail;
